module.exports = [{
    "": {
        "META_TITLE": "ZuluTrade - Sign Up for Free and Trade Your Way to Success",
        "META_DESCRIPTION": "Join ZuluTrade today. Access a wide range of financial assets and resources for social trading. Sign up for free and start social trading with confidence!",
        "META_KEYWORDS": "",
    },
    "forgot-password": {
        "META_TITLE": "ZuluTrade - Forgot Password",
        "META_DESCRIPTION": "Forgot your ZuluTrade password? No worries, we've got you covered. Enter your email address and we'll send you instructions on how to reset your password.",
        "META_KEYWORDS": "",
    },
    "select-a-broker": {
        "META_TITLE": "ZuluTrade Broker Partners",
        "META_DESCRIPTION": "Choose from a list of our trusted broker partners and start trading with ZuluTrade today.",
        "META_KEYWORDS": "",
    },
}]